import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { certificatesData } from "../../portfolioData";
import "./index.css";

const Certificates = () => {
  const theme = useSelector((state) => state.theme);
  const textColor =
    theme === "LIGHT" ? "certificates-light" : "certificates-dark";

  const certificateCardClass =
    theme === "LIGHT" ? "certificate-card-light" : "certificate-card-dark";

  const certificateCard = (certificate) => {
    const { title, imageUrl, certificateLink } = certificate;

    return (
      <Link to={certificateLink} target="blank">
        <div className={`certificate-card ${certificateCardClass}`}>
          <h3 className="certificate-card-title">{title}</h3>
          <img
            src={imageUrl}
            className="certificate-card-image"
            alt="certificate"
          />
        </div>
      </Link>
    );
  };

  return (
    <div className={`certificates ${textColor}`}>
      <h1 className="certificates-title">My Certificates</h1>
      <p className="certificates-caption">
        A glimpse into my journey through certificates
      </p>
      <hr
        style={{
          background:
            theme === "LIGHT"
              ? "rgba(0, 0, 0, 0.10)"
              : "rgba(255, 255, 255, 0.10)",
          width: "100vw",
          position: "relative",
          left: "calc((100% - 100vw) / 2)",
        }}
      />
      <ul className="certificates-container row">
        {certificatesData.map((certificate) => (
          <li key={certificate.id} className="col-12 col-md-6 col-lg-4">
            {certificateCard(certificate)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Certificates;
